import { TFunction } from 'i18next';
import TextCell from '@lib/components/Table/commonComponents/TextCell/TextCell';
import CategoryCell from '@lib/components/Table/commonComponents/CategoryCell/CategoryCell';
import { CellProps, Column } from '@lib/components/Table/types';

export type CategoryAnalyticsRow = {
  id: string;
  categoryId: string;
  name: string;
  color?: string | null;
  viewCount: number;
  percentage: number;
};

export default function getCategoryTableColumns(
  t: TFunction<'translation', undefined>,
): Column<CategoryAnalyticsRow>[] {
  return [
    {
      id: 'categoryName',
      Header: t('category'),
      Cell: ({ item }: CellProps<CategoryAnalyticsRow>) => (
        <CategoryCell label={item.name} color={item.color || undefined} />
      ),
      minWidth: 180,
      maxWidth: 180,
      sortable: true,
    },
    {
      id: 'viewCount',
      Header: t('view-count'),
      accessorFn: ({ item }) => String(item.viewCount),
      Cell: (props: CellProps<CategoryAnalyticsRow>) => <TextCell {...props} />,
      minWidth: 120,
      width: 140,
      sortable: true,
    },
    {
      id: 'percentage',
      Header: '%',
      accessorFn: ({ item }) => `${Math.round(item.percentage)}%`,
      Cell: (props: CellProps<CategoryAnalyticsRow>) => <TextCell {...props} />,
      minWidth: 90,
      width: 100,
      sortable: true,
    },
  ];
}
